<template>
  <div class="container">
    <img :src="url" alt @error="url = yesterdayUrl">
  </div>
</template>

<script>
export default {
  data () {
    return {
      url: '',
      yesterdayUrl: ''
    }
  },
  created () {
    this.init()
  },
  methods: {
    init () {
      let date = new Date()

      let currentDate = date.getDate()

      let str = '2022-03-' + (currentDate < 10 ? '0' + currentDate : currentDate)
      let yesterdayStr = '2022-03-' + ((currentDate - 1) < 10 ? '0' + (currentDate - 1) : (currentDate - 1))
      this.url = `https://jc-1300322797.cos.ap-shanghai.myqcloud.com/static/abiduoli/${str}.jpg?${Date.now()}`
      this.yesterdayUrl = `https://jc-1300322797.cos.ap-shanghai.myqcloud.com/static/abiduoli/${yesterdayStr}.jpg?${Date.now()}`
    }
  }
}
</script>

<style lang="scss" scoped>
.container {
  text-align: center;
  img {
    width: 52%;
  }
}
</style>